import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale);

export default class CountChart extends React.Component<any> {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick(event, activeElements) {
        if(activeElements && activeElements.length > 0) {
            const bar = activeElements[0];
            const label = bar._chart.config.data.labels[bar._index];
            this.props.onClick(label);
        } else {
            console.warn('User clicked on chart, but not any particular bar');
        }
    }

    render() {
        const counts = Object.values(this.props.counts).map((array: any[]) => array.length);
        const chartData = {
            labels: Object.keys(this.props.counts),
            datasets: [
                {
                    label: (this.props.label || 'Email Count'),
                    data: counts,
                    backgroundColor: counts.map(
                        count => {
                            return count > this.props.average ? 'rgba(180, 0, 0, 0.8)' : 'rgba(0, 180, 0, 0.8)';
                        }
                    )
                }
            ]
        };
        const options: any = {
            aspectRatio: 3
        };
        if(this.props.onClick) {
            options.onClick = this.onClick;
        }
        return (
            <Bar data={chartData} width={null} height={null} options={options}/>
        );
    }

}
